<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/security/">Security</a></li>
      <li class="breadcrumb-item active" aria-current="page">Security Type</li>
    </ol>
  </nav>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <div class="row mt-3">
          <div class="col">
            <h2 class="text-black ml-1 mb-3">Security Types</h2>
            <label class="d-block"><b>Group :</b> {{group.groupCode}}</label>
            <label class="d-block"><b>Description :</b> {{group.groupDescription}}</label>
          </div>
        </div>
        </div>
      <div class="inner-box" style="overflow:overlay;">
        <div class="row mt-3">
          <div class="col">
            <table class="table table-stripe">
              <thead>
              <tr>
                <th>Id</th>
                <th>Code</th>
                <th>Name</th>
                <th>Dependent On</th>
                <th>Access Type</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let g of group.securityTypes">
                <td>{{g.securityTypeId}}</td>
                <td>{{g.securityCode}}</td>
                <td>{{g.securityName}}</td>
                <td>{{g.dependentOn}}</td>
                <td>{{g.accessType}}</td>
                <td>
                  <a>
                    <div class="toggle-2">
                      <input type="checkbox" name="onoffswitch" id="customSwitch_{{g.securityTypeId}}" class="custom-control-input" (click)="changeStatus(g)" [checked]="g.status==='ACTIVE'" class="checkbox" />
                      <label for="customSwitch_{{g.securityTypeId}}" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div>
                   <!-- <div class="custom-control custom-switch">
                      <input type="checkbox"  class="custom-control-input" (click)="changeStatus(g)" id="customSwitch_{{g.securityTypeId}}" [checked]="g.status==='ACTIVE'">
                      <label class="custom-control-label" for="customSwitch_{{g.securityTypeId}}"> </label>
                    </div>-->
                  </a>
                </td>
              </tr>
<!--
              <tr>
                <td></td>
                <td><input type="text" id="securityType" [(ngModel)]="securityType" class="form-control width-120" [ngClass]="{'is-invalid':securityCodeError}" (blur)="typeCode()" [ngModelOptions]="{standalone: true}" required></td>
                <td><input type="text" id="securityName" [(ngModel)]="securityName" class="form-control width-120" [ngClass]="{'is-invalid':securityNameError}" (blur)="typeName()" [ngModelOptions]="{standalone: true}" required></td>
                <td>&lt;!&ndash;<div class="form-group mt-3 required">
                  <select id="dependentOn" class="form-control" [(ngModel)]="dependentOn" [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':accessTypeError}" (blur)="typeAccess()" required>
                    <option *ngFor="let s of groupActive.securityTypes" [ngValue]="s.securityTypeId">{{s.securityCode}}</option>
                  </select>
                </div>&ndash;&gt;
                  <input type="text" id="dependentOn" [(ngModel)]="dependentOn" class="form-control width-120" [ngModelOptions]="{standalone: true}" required>
                </td>
                <td><div class="form-group mt-3 required">
                  <select id="typeAccess" class="form-control" [ngClass]="{'is-invalid':accessTypeError}" (blur)="typeAccess()" [(ngModel)]="accessType" [ngModelOptions]="{standalone: true}" required>
                    <option *ngFor="let s of getSecurityTypes" [ngValue]="s.config">{{s.config}}</option>
                  </select>
                </div></td>
                <td><button type="button" class="btn btn-outline-primary" (click)="submitSecurity()">Add new</button></td>
              </tr>
-->
              </tbody>
            </table>
            <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!securityCodeError">{{securityCodeError}}</div>
            <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!securityNameError">{{securityNameError}}</div>
            <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!dependentError">{{dependentError}}</div>
            <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!accessTypeError">{{accessTypeError}}</div>
          </div>
        </div>
      </div>
    </div>
  </div><br><br>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/security" class="btn btn-cancel">Close</button>
    </div>
  </div>
</div>
